export enum SuggestionStatus {
    SUBMITED = 'SUBMITED',
    ACCEPTED = 'ACCEPTED'
}